import React, { useEffect } from 'react';
import { fetchHospital } from '@redux/hospitals/actions';
import { useDispatch, useSelector } from 'react-redux';
import { usePageActions } from '@hooks';
import { fetchPathwaySnapshots, fetchPathways } from '@pathways/redux/pathways/actions';
import { selectPathway, selectPathwaySnapshots } from '@pathways/redux/pathways/reducers';
import PathwayTitle from './PathwayTitle';
import PathwayDetailsBody from './PathwayDetailsBody';
import {
  CopyPathway,
  ShareSnapshot,
  EditPathway,
  PublishPathway,
  DeletePathway,
  CreateSnapshot,
} from './PathwayDetailsActions';

function PathwayDetails({ match }) {
  const dispatch = useDispatch();

  const pathwayId = Number(match.params.id);
  const snapshotNumber = Number(match.params.snapshot);

  useEffect(() => {
    dispatch(fetchHospital());
    dispatch(fetchPathways());
    dispatch(fetchPathwaySnapshots(pathwayId));
  }, [dispatch, pathwayId]);

  const { setActions, setTitle } = usePageActions({
    actions: [],
    showBack: true,
    title: '',
  });

  const [, parentPathway] = useSelector(state => selectPathway(state, pathwayId));
  const snapshots = useSelector(selectPathwaySnapshots(pathwayId));
  const selectedSnapshot = snapshots.find(snap => snap.snapshotNumber === snapshotNumber);

  useEffect(() => {
    setTitle(
      <PathwayTitle
        pathway={parentPathway}
        snapshots={snapshots}
        currentSnapshot={selectedSnapshot}
      />,
    );

    if (selectedSnapshot) {
      setActions([
        <ShareSnapshot parentPathwayId={pathwayId} pathway={selectedSnapshot} />,
        <CreateSnapshot pathway={selectedSnapshot} disabled />,
        <CopyPathway pathway={selectedSnapshot} />,
        <PublishPathway pathway={selectedSnapshot} disabled />,
        <DeletePathway pathway={selectedSnapshot} disabled />,
        <EditPathway disabled />,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentPathway?.id, pathwayId, selectedSnapshot, snapshots.length]);

  return <PathwayDetailsBody pathway={selectedSnapshot} />;
}

export default PathwayDetails;
